import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.active = true
    this.frame = this.element.closest("turbo-frame")
    if (!this.frame) return
    const url = new URL(this.urlValue, document.baseURI).href
    if (this.frame.src !== url) this.frame.src = url
    this.schedule()
  }

  disconnect() {
    this.active = false
    clearTimeout(this.timer)
    this.timer = null
  }

  schedule() {
    if (!this.active || !this.element.querySelector("[data-studio-poll-pending]")) return

    this.timer = setTimeout(async () => {
      this.timer = null
      try {
        if (document.visibilityState === "visible") await this.frame.reload()
      } finally {
        this.schedule()
      }
    }, 5000)
  }
}
